import { render, staticRenderFns } from "./RoundsList.vue?vue&type=template&id=3828f2b9&scoped=true&"
import script from "./RoundsList.vue?vue&type=script&lang=js&"
export * from "./RoundsList.vue?vue&type=script&lang=js&"
import style0 from "./RoundsList.vue?vue&type=style&index=0&id=3828f2b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3828f2b9",
  null
  
)

export default component.exports